import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { showModal } from '@store/actions/commonAction';
import {
  searchPlanList,
  changeSearchParam,
  changePlanList,
  searchDeletePlanList,
  infiniteSearchPlanList,
  infiniteSearchDelPlanList,
  changeDelSearchParam,
  changeDelSearchPayload,
  savePlan,
  checkSubscription,
  checkOmniUndecidedEnable,
} from '@store/actions/planListAction';
import {
  planFinancialPDF,
  changePdfInfo,
  searchFinancialBookmark,
} from '@store/actions/pdfViewerAction';
import {
  updateOriginCustomerInfo,
  searchCustomerByCustNo,
  getPlanListCustomerConstraint,
} from '@store/actions/customerAction';
import { checkProduct } from '@common/utils/index';
import {
  showEaPopup,
  hideEaPopup,
  searchEaBookmark,
} from '@store/actions/eaAction';
import * as preUwAction from '@store/actions/preUwAction';
import {
  hideOmniPopup,
  showOmniPopup,
  cancelSendOmni,
} from '@store/actions/omniAction';
import { useHistory } from 'react-router-dom';
import SatModal from '@components/common/satUI/SatModal';
import PlanListMenu from '@components/planList/PlanListMenu';
import ConstractList from '@components/planList/ConstractList';
import DeleteConstractList from '@components/planList/DeleteConstractList';
import PDFViewer from '@container/pdfviewer/index';
import EaIndex from '@container/ea/EaIndex';
import EaPartSubMain from '@container/ea/EaPartSubMain';
import OmniIndex from '@container/omni/OmniIndex';
import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';
import ComingSoonPopup from '@components/common/ComingSoonPopup';
import { DrawablePdfProvider } from '@common/hooks/useDrawablePdf';
import { isBeforeDay, isAfterDay, getToday } from '@common/utils/date';
import { parse, format } from 'date-fns';
import {
  REVISION_DATE,
  TRANSFER_DATE,
  // REVISION_DATE_DISABLE_MSG_PRODUCT_LIST,
} from '@common/constants';
import { savePalnCompCd } from '@store/actions/planAction';
import StopPlanPop from '@components/common/StopPlanPop';
import EaSelectModal from './modals/EaSelectModal';
import PreUwReqStatListMain from '@container/planList/PreUwReqStatListMain';

// 개발 임시 주석처리
// const UPWARD_DATE_DISABLE_MSG =
//   '보험산출일 제약으로 청약진행이 불가합니다. 새로이 가입설계를 진행하여 주시기 바랍니다.';
const REVISION_DATE_DISABLE_MSG = `${format(
  parse(REVISION_DATE, 'yyyy.MM.dd', new Date()),
  'yyyy년 MM월 dd일',
)} 개정에 따라 사용 불가한 청약서입니다. 산출기준일을 변경하여 새로 발급해 주시기 바랍니다.`;
const REVISION_DATE_DISABLE_MSG2 = `2022년 07월 01일 개정에 따라 사용 불가한 청약서입니다. 산출기준일을 변경하여 새로 발급해 주시기 바랍니다.`;

const PlanListMain = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    router: { location },
    commonReducer: { isLoading, checkRdopCont: checkRdopContList },
    eaReducer: { isShowEaPopup },
    omniReducer: { isShowOmniPopup },
    pdfViewerReducer: { financialPDFInfo, pdfViewStatus },
  } = useSelector(state => state);
  const [popupVisible, setPopupVisible] = useState(false);
  const [pdfVisible, setPdfVisible] = useState(false);
  const [pdfErrorPopup, setPdfErrorPopup] = useState(false);
  // 설계제목 변경 팝업
  const [changeTitlePopup, setChangeTitlePopup] = useState(false);
  const [changeTitleNo, setChangeTitleNo] = useState(0);
  const [planTitle, setPlanTitle] = useState('');
  const titleInputRef = useRef();
  // 설계목록 고객명
  const searchNameRef = useRef();
  const [customerName, setCustomerName] = useState('');
  const [completePopup, setCompletePopup] = useState(false);
  // 모바일 청약 진행 버튼
  const [isSelectRow, setIsSelectRow] = useState({});
  const [progressPopup, setProgressPopup] = useState(false);
  // 옴니청약 발송 취소
  const [isCancelOmniPopup, setIsCanceOmniPopup] = useState(false);
  // 청약진행 불가
  const [isNotProgress, setIsNotProgress] = useState(false);
  const [isNotProgressMsg, setIsNotProgressMsg] = useState('');
  // 부분 재발행
  const [eaPartSubPopup, setEaPartSubPopup] = useState(false);
  //설계중지 팝업
  const [showStopPlanPop, setShowStopPop] = useState(false);
  // 로그아웃
  const [isLogin, setIsLogin] = useState(false);

  // 준비 중 팝업
  const [noUndecidedDocDataList, setNoUndecidedDocDataList] = useState([]); // 부분 재발행시 보완서류 데이터 없는 목록
  const [checkDocList, setCheckDocList] = useState([]);
  const [searchDate, setSearchDate] = useState({
    fromDate: $utils.getPlanListSearchDates('list', 'start'),
    toDate: $utils.getPlanListSearchDates('list', 'end'),
  });
  const { searchParam, planList, delPlanList, delSearchParam } = useSelector(
    state => state.planListReducer,
  );
  //회사 선택옵션값
  const [selectCompayValue, setSelectCompayValue] = useState('ALL');

  // 설계목록 메뉴 정보
  const [menuInfo, setMenunfo] = useState([
    { label: '전체', grp: 'planList', value: 'all', active: 'active' },
    { label: '발행된 설계', grp: 'planList', value: 'excute', active: '' },
    { label: '즐겨찾기', grp: 'planList', value: 'favorite', active: '' },
    { label: '삭제된 설계', grp: 'planList', value: 'del', active: '' },
    {
      label: '사전심사 요청현황',
      grp: 'preUwReqStatList',
      value: 'preUwReqStatList',
      active: '',
    },
  ]);

  // 전차청약 팝업 노출 여부
  const setEaMainPopup = isShow => {
    if (isShow) dispatch(showEaPopup());
    else dispatch(hideEaPopup());
  };

  // 옴니 팝업 노출 여부
  const setOmniMainPopup = isShow => {
    if (isShow) dispatch(showOmniPopup());
    else dispatch(hideOmniPopup());
  };

  // Robin: 상품 종류 판단 로직이 As-is (상품 코드 앞4자리) => To-be (해당 상품 속성) 방식으로 변경 예정되어
  // /utils/project.js 에 있는 checkProduct() 함수 사용으로 변경
  // // REVISION_DATE_DISABLE_MSG 보여지는 상품인지 판단
  // const isDisableProductCheck = productCode =>
  //   REVISION_DATE_DISABLE_MSG_PRODUCT_LIST.find(v => productCode.startsWith(v));

  //화면 처음 들어올때 searchParam 초기화
  useEffect(() => {
    if (checkRdopContList.length > 0) {
      setShowStopPop(true);
    }
    dispatch(
      changeSearchParam({
        ...searchParam,
        delType: 'N',
        favoriteType: 'ALL',
        excuteFinancial: 'ALL',
        compCd: 'ALL',
        pageIndex: '1',
      }),
    );
  }, []);

  useEffect(() => {
    setSelectCompayValue(searchParam.compCd);
  }, [searchParam]);

  // 전체 설계 보기
  const handlerViewAll = () => {
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        excuteFinancial: 'ALL',
        favoriteType: 'ALL',
        isLast: false,
      }),
    );
    dispatch(searchPlanList());
  };

  // 발행된 설계만 보기 checkBox
  const onChangeExcuteFinancialBtn = () => {
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        excuteFinancial: 'Y',
        favoriteType: 'ALL',
        isLast: false,
      }),
    );
    dispatch(searchPlanList());
  };

  // 관심설계만 보기 checkBox
  const onChangeFavoriteTypeBtn = () => {
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        favoriteType: 'Y',
        excuteFinancial: 'ALL',
        isLast: false,
      }),
    );
    dispatch(searchPlanList());
  };

  // 삭제목록 버튼
  const onClickDelType = () => {
    setPopupVisible(true);
  };

  // 체크박스 선택
  const onChangeCheckBox = value => {
    const changeData = {
      ...value,
      isChecked: value.isChecked ? false : true,
    };
    dispatch(changePlanList(changeData));
  };

  // 설계일자 sort 클릭
  const onClickSortBtn = () => {
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        sort: searchParam.sort.includes('desc')
          ? 'planEstbDd,asc'
          : 'planEstbDd,desc',
        sort1: 'planEstbNo,desc',
        // sort1: searchParam.sort1.includes('desc')
        //   ? 'createDateTime,asc'
        //   : 'createDateTime,desc',
        isLast: false,
      }),
    );
    dispatch(searchPlanList());
  };

  // 가입제안서 버튼
  const onClickPdfViewerBtn = value => {
    dispatch(
      changePdfInfo({
        planEstablishNo: value.planEstablishNo,
        applicationNo: value.applicationNo,
        fileType: 'F',
        virtlPlanYn: value.virtlPlanYn,
      }),
    );
    dispatch(
      planFinancialPDF({
        planEstablishNo: value.planEstablishNo,
        applicationNo: value.applicationNo,
        fileType: 'F',
        callback: pdfCallbackSuccess,
      }),
    );
  };

  // 대면전자청약작성중 버튼
  const onClickElctronicBtn = (value, isConstractChange) => {
    const callback = (insuredCustData, ownerCustData, severToday) => {
      /* 개발 임시 주석처리
      // 상령일에 따른 청약 작성 불가
      if (
        value.rePublishYn !== 'Y' &&
        !isValidationByUpWardDate(
          value.calculateDate,
          insuredCustData.upWardDate,
          severToday,
        )
      ) {
        handleOpenPopup(UPWARD_DATE_DISABLE_MSG);
        return;
      }
      */

      // 개정일에 따른 청약 불가22 - 재발행은 제외
      if (
        value.rePublishYn !== 'Y' &&
        !isValidationByTransferDate2(
          value.planEstablishDate,
          value.calculateDate,
          severToday,
        )
      ) {
        handleOpenPopup(REVISION_DATE_DISABLE_MSG2);
        return;
      }

      // 개정일에 따른 청약 불가 - 재발행은 제외
      if (
        value.rePublishYn !== 'Y' &&
        !isValidationByTransferDate(
          value.planEstablishDate,
          value.calculateDate,
          severToday,
          // Robin: 상품종류 판단 로직이 상품 코드 앞 4자리 => 상품 속성으로 변경되어 수정
          // value.mainProductCode,
          value,
        )
      ) {
        handleOpenPopup(REVISION_DATE_DISABLE_MSG);
        return;
      }

      dispatch(
        checkSubscription({
          plan: { ...value, isConstractChange },
          callback: callbackElectronicBtn,
        }),
      );
    };
    setIsSelectRow({ ...value, isConstractChange });

    // 상령일 정보 조회
    handleSearchCustomerByCustNo(
      value.insuredPrspCustNo,
      value.calculateDate,
      value.ownerPrspCustNo,
      callback,
    );
  };

  // 대면전자청약작성중(청약서류보완) 버튼 누르고 진행가능여부 체크 API 콜백
  const callbackElectronicBtn = (value, type) => {
    if (type === 'OK') {
      dispatch(
        changePdfInfo({
          planEstablishNo: value.planEstablishNo,
          applicationNo: value.applicationNo,
          fileType: value.isConstractChange ? 'E' : 'P', // E :  청약서 변경, P : 청약서 PDF 체크
          virtlPlanYn: value.virtlPlanYn,
        }),
      );
      dispatch(
        planFinancialPDF({
          ...value,
          fileType: value.isConstractChange ? 'E' : 'P', // E :  청약서 변경, P : 청약서 PDF 체크
          callback: electricCallback,
        }),
      );
    } else if (type === 'RS_CHANGE') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '청약서 발행 후 상품내용 변경으로 청약진행이 불가합니다. 새로이 가입설계를 진행하여 주시기 바랍니다.',
      );
    } else if (type === 'AGE_CHANGE') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '청약서 발행 후 보험연령 변경으로 청약진행이 불가합니다. 새로이 가입설계를 진행하여 주시기 바랍니다.',
      );
    } else if (['AGREE_OVER', 'AGREE_NOT_FOUND'].includes(type)) {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '가입설계동의가 유효기간 이내의 경우 청약진행이 가능합니다. 가입설계동의를 진행해 주시기 바랍니다.',
      );
    } else if (type === 'PRD_SALES_STOP') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '보험판매자격이 없는 경우 모바일청약 진행 불가합니다.',
      );
    } else if (type === 'VAR_SALES_STOP') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '변액판매자격 미취득한 경우 변액계약의 모바일청약 진행 불가합니다.',
      );
    } else if (type === 'OMN_ABLE_OVER') {
      toast('전자청약은 청약시작 당일에 이어하기 가능합니다.');
      return;
    } else if (type === 'DM_DB_NOT_USE') {
      setIsNotProgress(true);
      setIsNotProgressMsg('배정된 고객이 아닌 경우 청약진행이 불가합니다.');
    } else {
      setIsNotProgress(false);
      setIsNotProgressMsg('');
    }
  };

  // 전자청약(서류보완) 작성 중 진행 가능 확인 콜백
  const electricCallback = ({ type, data, payload }) => {
    if (type) {
      if (data.rePublishYn === 'Y') {
        if (['Q'].includes(payload.progressStep))
          handleEaBookmarkSearch(payload);
        else setProgressPopup(true);
      } else {
        handleEaBookmarkSearch(payload);
      }
    }
  };

  const pdfCallbackSuccess = ({ type, data }) => {
    if (type) {
      if (data.status === 'R') {
        setPdfErrorPopup(true);
      } else {
        const { planEstablishNo, fileType } = data;
        if (fileType === 'F') {
          dispatch(
            searchFinancialBookmark({
              planEstablishNo: planEstablishNo,
              fileType: fileType,
            }),
          );
          setPdfVisible(true);
        }
      }
    }
  };

  // 옴니 청약 버튼
  const handleOmniBtnClick = (value, isConstractChange) => {
    dispatch(
      checkSubscription({
        plan: { ...value, isConstractChange },
        callback: (_, type) => {
          if (type === 'RS_CHANGE') {
            setIsNotProgress(true);
            setIsNotProgressMsg(
              '청약서 발행 후 상품내용 변경으로 청약진행이 불가합니다. 새로이 가입설계를 진행하여 주시기 바랍니다.',
            );
            return;
          } else if (type === 'AGE_CHANGE') {
            setIsNotProgress(true);
            setIsNotProgressMsg(
              '청약서 발행 후 보험연령 변경으로 청약진행이 불가합니다. 새로이 가입설계를 진행하여 주시기 바랍니다.',
            );
            return;
          } else if (['AGREE_OVER', 'AGREE_NOT_FOUND'].includes(type)) {
            setIsNotProgress(true);
            setIsNotProgressMsg(
              '가입설계동의가 유효기간 이내의 경우 청약진행이 가능합니다. 가입설계동의를 진행해 주시기 바랍니다.',
            );
            return;
          } else if (type === 'PRD_SALES_STOP') {
            setIsNotProgress(true);
            setIsNotProgressMsg(
              '보험판매자격이 없는 경우 모바일청약 진행 불가합니다.',
            );
            return;
          } else if (type === 'VAR_SALES_STOP') {
            setIsNotProgress(true);
            setIsNotProgressMsg(
              '변액판매자격 미취득한 경우 변액계약의 모바일청약 진행 불가합니다.',
            );
            return;
          } else if (type === 'OMN_ABLE_OVER') {
            toast('전자청약은 청약시작 당일에 이어하기 가능합니다.');
            return;
          } else if (type === 'DM_DB_NOT_USE') {
            setIsNotProgress(true);
            setIsNotProgressMsg(
              '배정된 고객이 아닌 경우 청약진행이 불가합니다.',
            );
          }

          const callback = (insuredCustData, ownerCustData, severToday) => {
            /* 개발 임시 주석처리
            // 상령일에 따른 청약 작성 불가
            if (
              value.rePublishYn !== 'Y' &&
              !isValidationByUpWardDate(
                value.calculateDate,
                insuredCustData.upWardDate,
                severToday,
              )
            ) {
              handleOpenPopup(UPWARD_DATE_DISABLE_MSG);
              return;
            }
            */

            // 개정일에 따른 청약 불가22 - 재발행은 제외
            if (
              value.rePublishYn !== 'Y' &&
              !isValidationByTransferDate2(
                value.planEstablishDate,
                value.calculateDate,
                severToday,
              )
            ) {
              handleOpenPopup(REVISION_DATE_DISABLE_MSG2);
              return;
            }
            // 개정일에 따른 청약 불가 - 재발행은 제외
            if (
              value.rePublishYn !== 'Y' &&
              !isValidationByTransferDate(
                value.planEstablishDate,
                value.calculateDate,
                severToday,
                // Robin: 상품종류 판단 로직이 상품 코드 앞 4자리 => 상품 속성으로 변경되어 수정
                // value.mainProductCode,
                value,
              )
            ) {
              handleOpenPopup(REVISION_DATE_DISABLE_MSG);
              return;
            }

            dispatch(
              changePdfInfo({
                planEstablishNo: value.planEstablishNo,
                applicationNo: value.applicationNo,
                fileType: isConstractChange ? 'E' : 'P', // E :  청약서 변경, P : 청약서 PDF 체크
                virtlPlanYn: value.virtlPlanYn,
              }),
            );

            setOmniMainPopup(true);
          };
          setIsSelectRow({ ...value, isConstractChange });

          // 상령일 정보 조회
          handleSearchCustomerByCustNo(
            value.insuredPrspCustNo,
            value.calculateDate,
            value.ownerPrspCustNo,
            callback,
          );
        },
      }),
    );
  };

  // 삭제목록 Sort
  const onClickDelSort = () => {
    dispatch(
      changeDelSearchParam({
        ...delSearchParam,
        page: 1,
        sort: delSearchParam.sort.includes('desc')
          ? 'fnlUpdDdtm,asc'
          : 'fnlUpdDdtm,desc',
        sort1: 'planEstbNo,desc',
        delIsLast: false,
      }),
    );
    dispatch(
      searchDeletePlanList({
        sort: delSearchParam.sort.includes('desc')
          ? 'fnlUpdDdtm,asc'
          : 'fnlUpdDdtm,desc',
        sort1: 'planEstbNo,desc',
      }),
    );
  };

  // 삭제목록 닫기
  const onCloseDelPlanList = () => {
    setPopupVisible(false);
    dispatch(
      changeDelSearchParam({
        ...delSearchParam,
        pageIndex: 1,
        sort: 'fnlUpdDdtm,desc',
        sort1: 'planEstbNo,desc',
        delIsLast: false,
      }),
    );
  };

  // 설계목록 scroll
  const handleScroll = flag => {
    if (flag && !isLoading) {
      dispatch(
        changeSearchParam({
          ...searchParam,
          pageIndex: searchParam.pageIndex + 1,
          custNo: location.state ? location.state.customerInfo.custNo : '',
        }),
      );
      dispatch(infiniteSearchPlanList());
    }
  };

  // 삭제목록 scroll
  const handleScrollForDelete = flag => {
    if (flag && !isLoading) {
      dispatch(
        changeDelSearchParam({
          ...delSearchParam,
          pageIndex: delSearchParam.pageIndex + 1,
          custNo: location.state ? location.state.customerInfo.custNo : '',
        }),
      );
      dispatch(infiniteSearchDelPlanList());
    }
  };

  // 가입설계 Detail 조회
  const onClickPlanDetail = value => {
    if (value.planLoadYn === 'N') {
      if (value.planLoadInfoMsg) {
        dispatch(
          showModal({
            visible: true,
            type: 'confirm',
            msg: value.planLoadMsg,
            onOk: {
              handle: () =>
                dispatch(
                  showModal({
                    visible: true,
                    type: 'info',
                    msg: value.planLoadInfoMsg,
                  }),
                ),
            },
          }),
        );
      } else {
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: value.planLoadMsg,
          }),
        );
      }
      return;
    }
    dispatch(savePalnCompCd(value.compCd));
    history.push({
      pathname: '/plan',
      state: {
        planEstablishNo: value.planEstablishNo,
        calculateDate: value.calculateDate,
      },
    });
  };

  // 설계제목변경팝업
  const handlerChangeTitlePopup = value => {
    const { planEstablishNo, planEstablishTitle } = value;
    setChangeTitleNo(planEstablishNo);
    setPlanTitle(planEstablishTitle);
    setChangeTitlePopup(true);
  };

  // 설계제목변경 Status
  const handlerChangePlanTitle = value => {
    if (value.length < 16) {
      setPlanTitle(value);
    } else {
      setPlanTitle(value.substring(0, 15));
    }
  };

  // 설계제목변경
  const changePlanTitle = () => {
    setChangeTitlePopup(false);
    setPlanTitle('');
    dispatch(
      savePlan({
        planEstablishNo: changeTitleNo,
        planEstablishTitle: planTitle,
      }),
    );
  };

  // 설계제목편집 Enter 누르면 Blur
  const handlerTitleBlur = () => {
    titleInputRef.current.onBlur();
  };

  // 고객명 검색 searchName 변경
  const handlerSearchName = value => {
    setCustomerName(value);
  };

  // 고객명 입력 후 엔터/blur
  const handlerBlurSearchName = () => {
    dispatch(
      changeSearchParam({
        ...searchParam,
        pageIndex: 1,
        searchName: customerName,
        searchStartDate: searchDate.fromDate,
        searchEndDate: searchDate.toDate,
      }),
    );

    // 검색어 빈 값일 경우 검색하지 않음
    if (!customerName?.trim?.()) return;

    searchNameRef.current.onBlur();
    dispatch(searchPlanList());
  };

  //회사 선택 콤보박스 검색
  const handlerSearch = compCd => {
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        searchName: customerName,
        searchStartDate: searchDate.fromDate,
        searchEndDate: searchDate.toDate,
        compCd: compCd,
      }),
    );
    dispatch(searchPlanList());
  };

  // 고객명 삭제
  const handlerDeleteSearchName = () => {
    // searchNameRef.current.onFocus();
    setCustomerName('');
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        searchName: '',
        searchStartDate: searchDate.fromDate,
        searchEndDate: searchDate.toDate,
      }),
    );
    dispatch(searchPlanList());
  };

  //날짜로 설계 목록 검색
  const handleDateSerchDate = (date, fromTo) => {
    console.log(fromTo);
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        searchName: '',
        searchStartDate: fromTo === 'from' ? date : searchDate.fromDate,
        searchEndDate: fromTo !== 'from' ? date : searchDate.toDate,
      }),
    );
    dispatch(searchPlanList());
  };

  // 모바일 청약 진행 버튼 클릭
  const onClickProgressBtn = (value, isConstractChange) => {
    const callback = (insuredCustData, ownerCustData, severToday) => {
      /* 개발 임시 주석처리
      // 상령일에 따른 청약 작성 불가
      if (
        value.rePublishYn !== 'Y' &&
        !isValidationByUpWardDate(
          value.calculateDate,
          insuredCustData.upWardDate,
          severToday,
        )
      ) {
        handleOpenPopup(UPWARD_DATE_DISABLE_MSG);
        return;
      }
      */

      // 개정일에 따른 청약 불가22 - 재발행은 제외
      if (
        value.rePublishYn !== 'Y' &&
        !isValidationByTransferDate2(
          value.planEstablishDate,
          value.calculateDate,
          severToday,
        )
      ) {
        handleOpenPopup(REVISION_DATE_DISABLE_MSG2);
        return;
      }

      // 개정일에 따른 청약 불가 - 재발행은 제외
      if (
        value.rePublishYn !== 'Y' &&
        !isValidationByTransferDate(
          value.planEstablishDate,
          value.calculateDate,
          severToday,
          // Robin: 상품종류 판단 로직이 상품 코드 앞 4자리 => 상품 속성으로 변경되어 수정
          // value.mainProductCode,
          value,
        )
      ) {
        handleOpenPopup(REVISION_DATE_DISABLE_MSG);
        return;
      }

      dispatch(
        checkSubscription({
          plan: { ...value, isConstractChange },
          callback: checkSubscriptionCallback,
        }),
      );
    };

    // tory님 요청으로 준비중 임시 해제
    // if (value.parentOmniYn === true && value.republishType === 'DOC') {
    //   // 기존 청약이 옴니인 부분재발행건의 경우 준비중입니다 팝업 노출
    //   setComingSoon(true);
    // } else {
    setIsSelectRow({ ...value, isConstractChange });

    // 상령일 정보 조회
    handleSearchCustomerByCustNo(
      value.insuredPrspCustNo,
      value.calculateDate,
      value.ownerPrspCustNo,
      callback,
    );
    // }
  };

  // 모바일 청약 진행(청약서류보완) 버튼 클릭 -> 전자청약 진행 가능 여부 체크 API 콜백
  const checkSubscriptionCallback = (value, type) => {
    if (type === 'OK') {
      dispatch(
        changePdfInfo({
          planEstablishNo: value.planEstablishNo,
          applicationNo: value.applicationNo,
          fileType: value.isConstractChange ? 'E' : 'P', // E :  청약서 변경, P : 청약서 PDF 체크
          virtlPlanYn: value.virtlPlanYn,
        }),
      );
      dispatch(
        planFinancialPDF({
          ...value,
          fileType: value.isConstractChange ? 'E' : 'P', // E :  청약서 변경, P : 청약서 PDF 체크
          callback: progreesCallback,
        }),
      );
    } else if (type === 'RS_CHANGE') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '청약서 발행 후 상품내용 변경으로 청약진행이 불가합니다. 새로이 가입설계를 진행하여 주시기 바랍니다.',
      );
    } else if (type === 'AGE_CHANGE') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '청약서 발행 후 보험연령 변경으로 청약진행이 불가합니다. 새로이 가입설계를 진행하여 주시기 바랍니다.',
      );
    } else if (['AGREE_OVER', 'AGREE_NOT_FOUND'].includes(type)) {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '가입설계동의가 유효기간 이내의 경우 청약진행이 가능합니다. 가입설계동의를 진행해 주시기 바랍니다.',
      );
    } else if (type === 'PRD_SALES_STOP') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '보험판매자격이 없는 경우 모바일청약 진행 불가합니다.',
      );
    } else if (type === 'VAR_SALES_STOP') {
      setIsNotProgress(true);
      setIsNotProgressMsg(
        '변액판매자격 미취득한 경우 변액계약의 모바일청약 진행 불가합니다.',
      );
    } else if (type === 'DM_DB_NOT_USE') {
      setIsNotProgress(true);
      setIsNotProgressMsg('배정된 고객이 아닌 경우 청약진행이 불가합니다.');
    } else {
      setIsNotProgress(false);
      setIsNotProgressMsg('');
    }
  };

  // 전자청약 진행 가능여부 체크 완료 후 -> PDF 생성 여부 체크 Callback
  const progreesCallback = ({ type, data, payload }) => {
    if (type) {
      if (data.status === 'R') {
        // PDF 발행이 아직 안됬을 경우
        setPdfErrorPopup(true);
      } else {
        const { planEstablishNo, fileType } = data;
        if (fileType === 'F') {
          // 가입제안서일 경우 가입제안서 목차 조회
          dispatch(
            searchFinancialBookmark({
              planEstablishNo: planEstablishNo,
              fileType: fileType,
            }),
          );
          setPdfVisible(true);
        } else {
          if (['Q'].includes(payload.progressStep)) {
            handleEaBookmarkSearch(payload);
          } else {
            if (data.rePublishYn === 'Y' && payload.republishType === 'DOC') {
              // 부분재발행 > 특별신체부위 질병, 감액법신청 정보가 없는 경우 옴니버튼 미노출해야함
              dispatch(
                checkOmniUndecidedEnable({
                  planEstablishNo: data.planEstablishNo,
                  applicationNo: data.applicationNo,
                  callback: callbackCheckOmniUndecidedEnable,
                }),
              );
            } else {
              setProgressPopup(true);
            }
          }
        }
      }
    }
  };

  const callbackCheckOmniUndecidedEnable = (
    status,
    noDataDocList,
    checkDocList,
  ) => {
    if (status) {
      //미결보완 시 특별신체부위 질병, 감액법신청 정보가 없는 경우 옴니버튼 클릭 시 불가 팝업
      setNoUndecidedDocDataList(noDataDocList ?? []); // 데이터 없는 문서 리스트
      setCheckDocList(checkDocList ?? []);
    } else {
      setNoUndecidedDocDataList([]);
    }
    setProgressPopup(true);
  };
  // to do api 다시 협의 해야 할듯
  // 재발행건 설계 진행 가능 여부 체크 callback
  // const callbackRepublish = value => {
  //   /*
  //   if (value.undecidedYn) {
  //     // 미결상태인 경우

  //       setProgressPopup(true);
  //       // if (value.progressStep === 'Q') {
  //       //   handleEaBookmarkSearch(value); // 대면 청약변경 진행 중인 경우 ProgressPopup 띄우지 않음
  //       // } else {
  //       //   setProgressPopup(true);
  //       // }

  //   } else {
  //     // 미결상태 아닌 경우
  //     setIsUndecidedPopup(true);
  //   }
  //   */
  //   //
  //   if (['Q'].includes(value.progressStep))
  //     handleEaBookmarkSearch(value);
  //   else setProgressPopup(true);
  // };

  // 옴니청약 발송 취소
  const hanldeOmniCancelBtnClick = value => {
    setIsSelectRow(value);
    setIsCanceOmniPopup(true);
  };

  // 옴니청약 발송 취소 확인
  const handleCancelConfirmBtn = () => {
    dispatch(
      cancelSendOmni({
        applicationNo: isSelectRow.applicationNo,
        callback: setIsCanceOmniPopup(false),
      }),
    );
  };

  // 전자청약 목차 조회
  const handleEaBookmarkSearch = value => {
    setProgressPopup(false);
    if (value) {
      // hanjy: fileType이 없고, 청약변경일 경우 'E' 적용
      dispatch(
        searchEaBookmark({
          planEstablishNo: value.planEstablishNo,
          fileType: value.fileType
            ? value.fileType
            : value.isConstractChange
            ? 'E'
            : 'P',
          callback: callbackBookmark(value),
        }),
      );
    }
  };

  const callbackBookmark = value => {
    if (value.rePublishYn === 'Y') {
      if (value?.republishType === 'DOC' || value.isConstractChange) {
        setEaPartSubPopup(true);
      } else {
        setEaMainPopup(true);
      }
    } else setEaMainPopup(true);
  };

  // 청약진행 불가 팝업 종료
  const handleIsNotProgressClose = () => {
    setIsNotProgress(false);
    if (isNotProgressMsg.includes('가입설계동의')) {
      // 고객 조회
      const cb = customer => {
        dispatch(updateOriginCustomerInfo(customer));
        history.push('/home/customerInfo');
      };

      dispatch(
        searchCustomerByCustNo({
          custNo: isSelectRow.insuredPrspCustNo,
          callback: cb,
        }),
      );
    }
  };

  // 로그아웃
  const handleLogoutBtnClick = () => {
    setIsLogin(false);
    dispatch(changeSearchParam({ ...searchParam, custNo: '' }));
    dispatch(searchPlanList());
  };

  // 고객 정보 검색 (상령일)
  const handleSearchCustomerByCustNo = useCallback(
    (custNo, calculateDate, ownerCustNo, callback) => {
      dispatch(
        getPlanListCustomerConstraint({
          custNo,
          calculateDate,
          ownerCustNo,
          callback,
        }),
      );
    },
    [],
  );

  // OP700 07.27 개발 임시 주석 처리 (???)
  // 상령일에 따른 청약 작성 가능 여부
  // const isValidationByUpWardDate = (calculate, upWard, severToday) => {
  //   try {
  //     const calculateDate = parse(calculate, 'yyyy.MM.dd', new Date());
  //     const upWardDate = parse(upWard, 'yyyyMMdd', new Date());
  //     const year = getYear(new Date());
  //     const month = getMonth(upWardDate);
  //     const date = getDate(upWardDate);
  //
  //     const upWardDateChangedYear = new Date(year, month, date);
  //     const upWardDatelastYear = new Date(year - 1, month, date);
  //     const upWardDateNextYear = new Date(year + 1, month, date);
  //
  //     const today = new Date(severToday);
  //
  //     const isCaluateDateBefore =
  //       isAfterDay(calculateDate, upWardDatelastYear) &&
  //       isBeforeDay(calculateDate, upWardDateChangedYear, false);
  //     const isCaluateDateAfter =
  //       isAfterDay(calculateDate, upWardDateChangedYear) &&
  //       isBeforeDay(calculateDate, upWardDateNextYear, false);
  //     const isTodayBefore =
  //       isAfterDay(today, upWardDatelastYear) &&
  //       isBeforeDay(today, upWardDateChangedYear, false);
  //     const isTodayAfter =
  //       isAfterDay(today, upWardDateChangedYear) &&
  //       isBeforeDay(today, upWardDateNextYear, false);
  //
  //     // 산출일이 상령일 보다 이전이고 오늘도 상령일 이전이다(전해 상령일 이전 이면안됨) -> 통과
  //     // 산출일이 상령일 보다 이후 이고 오늘도 상령일 이후이다.(다음 해 상령일 이후 이면안됨) -> 통과
  //     return (
  //       (isCaluateDateBefore && isTodayBefore) ||
  //       (isCaluateDateAfter && isTodayAfter)
  //     );
  //   } catch (e) {
  //     console.log('### PlanListMain.js isValidationByUpWardDate error => ' + e);
  //     return false;
  //   }
  // };

  // 이관일에 따른 청약 작성 가능 여부
  const isValidationByTransferDate = (
    (transfer, revision) =>
    (
      planEstablish, // 설계일자
      calculate, // 산출일자
      severToday,
      // Robin: 상품 종류 판단 로직이 상품코드 앞 4자리(As-is)에서
      // 상품 정보 객체 내 해당 속성 값(To-be 방식)으로 변경 예정이므로
      // 파라미터 상품 코드 => 상품 객체 정보 전체로 변경
      productInfo, // 주계약 상품 정보 객체
      // productCode, // 주계약상품코드
    ) => {
      try {
        // 청약진행일
        const today = new Date(severToday);

        // 이관일
        const transferDate = parse(transfer, 'yyyy.MM.dd', new Date());
        // 개정일
        const revisionDate = parse(revision, 'yyyy.MM.dd', new Date());
        // 설계일자(발행일)
        const planEstablishDate = parse(
          planEstablish,
          'yyyy.MM.dd',
          new Date(),
        );
        // 산출일자
        const calculateDate = parse(calculate, 'yyyy.MM.dd', new Date());

        // Robin: 상품 종류 판별 로직이
        // As-is(상품 코드 앞 4자리) => To-be(상품 속성으로 판단)으로 변경되어 수정
        // 특정 상품만 보여달라는 요건으로 해당 상품일 경우에만 아래 로직 타게 수정
        // if (isDisableProductCheck(productCode)) {
        if (checkProduct(productInfo, 'isDisableProductCheck')) {
          if (
            isAfterDay(planEstablishDate, transferDate) &&
            isBeforeDay(calculateDate, revisionDate, false) &&
            isAfterDay(today, revisionDate)
          ) {
            // 1)  이관 이후 발행 & 산출기준일 개정일 이전 : 개정일 이후 청약서 오픈 시 불가
            return false;
          } else if (
            isAfterDay(planEstablishDate, transferDate) &&
            isAfterDay(calculateDate, revisionDate) &&
            isBeforeDay(today, revisionDate, false)
          ) {
            // 2)  이관 이후 발행 & 산출기준일 개정일 이후 : 개정일 이전 청약서 오픈 시 불가
            return false;
          } else if (
            isBeforeDay(planEstablishDate, transferDate, false) &&
            isAfterDay(calculateDate, revisionDate) &&
            isAfterDay(today, revisionDate)
          ) {
            //  3)  이관 이전 발행 & 산출기준일 개정일 이후 : 개정일 이후 청약서 오픈 시 불가
            return false;
          } else if (
            isBeforeDay(planEstablishDate, transferDate, false) &&
            isBeforeDay(calculateDate, revisionDate, false) &&
            isAfterDay(today, revisionDate)
          ) {
            // 4) 이관 이전 발행 & 산출기준일 개정일 이전 : 개정일 이후 청약서 오픈 시 불가
            return false;
          }
        }

        return true;
      } catch (e) {
        console.log(
          '### PlanListMain.js isValidationByTransferDate error => ' + e,
        );
        return false;
      }
    }
  )(TRANSFER_DATE, REVISION_DATE);

  // 이관일에 따른 청약 작성 가능 여부 7월 이관
  const isValidationByTransferDate2 = (
    () =>
    (
      planEstablish, // 설계일자
      calculate, // 산출일자
      severToday,
    ) => {
      try {
        // 개발계에서는 개정일에 따른 제약 블락 없음
        // if ($utils.isDevLocal) return true;

        // 청약진행일
        const today = new Date(severToday);
        // 설계일자(발행일)
        const planEstablishDate = parse(
          planEstablish,
          'yyyy.MM.dd',
          new Date(),
        );
        // 산출일자
        const calculateDate = parse(calculate, 'yyyy.MM.dd', new Date());

        // SAT-4336 AC.4
        // 설계일자 : 2022.6.29일까지
        // 산출기준일 : 관계없음
        // 버튼 선택일 : 2022.7.1일 이후
        if (
          isBeforeDay(planEstablishDate, new Date('2022/06/29 23:59:59')) &&
          isAfterDay(today, new Date('2022/07/01 00:00:00'))
        ) {
          return false;
        } else if (
          isAfterDay(planEstablishDate, new Date('2022/06/30 00:00:00')) &&
          isAfterDay(calculateDate, new Date('2022/07/01 00:00:00')) &&
          isBeforeDay(today, new Date('2022/06/30 23:59:59'))
        ) {
          // 설계일자 : 2022.6.30일 이후
          // 산출기준일 : 2022.7.1일 이후
          // 버튼 선택일 : 2022.6.30일 까지
          // : 산출기준일이 7월1일 이후인 경우 개정본이기때문에 7월 1일 이전 사용 불가
          return false;
        } else if (
          isAfterDay(planEstablishDate, new Date('2022/06/30 00:00:00')) &&
          isBeforeDay(calculateDate, new Date('2022/06/30 23:59:59')) &&
          isAfterDay(today, new Date('2022/07/01 00:00:00'))
        ) {
          // 설계일자 : 2022.6.30일 이후
          // 산출기준일 : 2022.6.30일 까지
          // 버튼 선택일 : 2022.7.1일 이후
          // : 산출기준일이 6월 30일인 경우 개정본이 아니기 때문에 7월 1일 이후 사용 불가
          return false;
        }

        return true;
      } catch (e) {
        console.log(
          '### PlanListMain.js isValidationByTransferDate2 error => ' + e,
        );
        return false;
      }
    }
  )(TRANSFER_DATE, REVISION_DATE);

  // 팝업 닫기 후 재조회
  const handleReSearch = useCallback(
    (searchParam => () => {
      dispatch(changeSearchParam({ ...searchParam, page: 1 }));
      dispatch(searchPlanList());
    })(searchParam),
    [dispatch],
  );

  // 단순 inform 팝업 열기
  const handleOpenPopup = useCallback(msg => {
    dispatch(
      showModal({
        visible: true,
        type: 'info',
        msg: msg,
      }),
    );
  }, []);

  // 설계목록 바로가기로 왔을때 조회 조건 설정
  const setShortcutCustomerInfo = state => {
    dispatch(
      changeSearchParam({
        ...searchParam,
        page: 1,
        custNo: state.customerInfo.custNo,
      }),
    );
    dispatch(
      changeDelSearchParam({
        ...delSearchParam,
        page: 1,
        custNo: state.customerInfo.custNo,
      }),
    );
  };

  useEffect(() => {
    const { state } = location;
    if (state && Object.prototype.hasOwnProperty.call(state, 'customerInfo')) {
      setShortcutCustomerInfo(state);
      setIsLogin(true);
    }

    dispatch(searchPlanList());
  }, [location]);

  // 삭제목록 조회
  useEffect(() => {
    if (popupVisible) {
      // firebase.analytics().logEvent('screen_view', {
      //   firebase_screen: '삭제목록',
      //   firebase_screen_class: 'DeleteList',
      // });

      dispatch(
        changeDelSearchPayload({
          pageConditionKey: '',
          pageCount: 10,
          pageNextYn: '',
          pageTotalCount: 0,
        }),
      );
      dispatch(
        searchDeletePlanList({
          sort: 'fnlUpdDdtm,desc',
          sort1: 'planEstbNo,desc',
        }),
      );
    }
  }, [popupVisible]);

  // 설계제목 포커스
  useEffect(() => {
    if (changeTitlePopup && titleInputRef.current)
      titleInputRef.current.onFocus();
  }, [changeTitlePopup]);

  useEffect(() => {
    setCustomerName(searchParam.searchName);
  }, [searchParam.searchName]);

  useEffect(() => {
    // PdfViewer 사용 중 location 변경에 의해 pdf url이 초기화(initPdfState)되는 경우,
    // PdfViewer가 url을 찾지 못해 에러가 발생하므로 PdfViewer 닫기 처리
    if (!pdfViewStatus.data) {
      setPdfVisible(prev => {
        return prev ? !prev : prev;
      });
    }
  }, [pdfViewStatus.data]);

  // 메뉴 변경
  const handleChangeMenuInfo = value => {
    switch (value) {
      // 전체
      case 'all':
        handlerViewAll();
        break;
      // 발행된 설계
      case 'excute':
        onChangeExcuteFinancialBtn();
        break;
      // 즐겨찾기
      case 'favorite':
        onChangeFavoriteTypeBtn();
        break;
      // 삭제된 설계
      case 'del':
        onClickDelType();
        break;
      // 사전심사 요청현황
      case 'preUwReqStatList':
        // 활성화 상태에서 메뉴 클릭시 재조회
        if (menuInfo.find(info => info.active === 'active').value === value) {
          dispatch(preUwAction.savePreUwRequestSuccess());
        }
        break;
    }

    // 메뉴 정보 갱신
    setMenunfo(prev =>
      prev.map(info => {
        return {
          ...info,
          active: `${info.value === value ? 'active' : ''}`,
        };
      }),
    );
  };

  return (
    <div className="wide-con-wrap">
      <PlanListMenu
        menuInfo={menuInfo}
        onChangeMenuInfo={handleChangeMenuInfo}
      />
      {/* 활성화(active) 사태의 메뉴가 planList일 경우, 설계목록 그 외에는 사전심사 요청현황 */}
      {menuInfo.find(info => info.active === 'active').grp === 'planList' ? (
        <ConstractList
          planList={planList}
          searchParam={searchParam}
          onChangeCheckBox={onChangeCheckBox}
          onClickSortBtn={onClickSortBtn}
          onClickPdfViewerBtn={onClickPdfViewerBtn}
          onClickPlanDetail={onClickPlanDetail}
          onClickElctronicBtn={onClickElctronicBtn}
          onClickChangeTitleBtn={handlerChangeTitlePopup}
          onClickOmniBtn={handleOmniBtnClick}
          onClickProgressBtn={onClickProgressBtn}
          onClickOmniCancelBtn={hanldeOmniCancelBtnClick}
          onScroll={handleScroll}
          isLogin={isLogin}
          searchNameRef={searchNameRef}
          customerName={customerName}
          onClickDeleteSearchName={handlerDeleteSearchName}
          onChangeSearchName={handlerSearchName}
          onPressEnter={handlerBlurSearchName}
          customerInfo={location.state}
          onClickLogoutBtn={handleLogoutBtnClick}
          searchDate={searchDate}
          setSearchDate={setSearchDate}
          searchListFormDate={handleDateSerchDate}
          compCd={selectCompayValue}
          setCompCd={setSelectCompayValue}
          handlerSearch={handlerSearch}
        />
      ) : (
        <PreUwReqStatListMain />
      )}

      <SatModal
        visible={popupVisible}
        setVisible={() => onCloseDelPlanList()}
        type="fullPop"
      >
        <DeleteConstractList
          delPlanList={delPlanList}
          delSearchParam={delSearchParam}
          onClickDelSort={onClickDelSort}
          onClickPdfViewerBtn={onClickPdfViewerBtn}
          onScroll={handleScrollForDelete}
          onClickPlanDetail={onClickPlanDetail}
          onClickElctronicBtn={onClickElctronicBtn}
          onClickOmniBtn={handleOmniBtnClick}
          onClickProgressBtn={onClickProgressBtn}
          onClickOmniCancelBtn={hanldeOmniCancelBtnClick}
          onClose={() => onCloseDelPlanList()}
        />
      </SatModal>

      <SatModal
        type="fullPop"
        visible={pdfVisible}
        setVisible={() => {
          setPdfVisible(false);
          handleReSearch();
        }}
      >
        <DrawablePdfProvider>
          <PDFViewer
            visible={pdfVisible}
            fileType={financialPDFInfo.fileType}
            url={$utils.makeEaPdfUrl(pdfViewStatus.data)}
            setPdfVisible={flag => {
              setPdfVisible(flag);
              handleReSearch();
            }}
            planEstablishNo={financialPDFInfo.planEstablishNo}
            applicationNo={financialPDFInfo.applicationNo}
          />
        </DrawablePdfProvider>
      </SatModal>

      <SatModal
        visible={pdfErrorPopup}
        setVisible={() => {
          setPdfErrorPopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text text-center">
                  {financialPDFInfo.fileType === 'F'
                    ? '지금 문서를 발행하는 중입니다. 잠시 후에 확인하세요.'
                    : '지금 청약 문서를 발행하는 중입니다. 잠시 후에 다시 시도해주세요.'}
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => setPdfErrorPopup(false)}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={changeTitlePopup}
        type="info"
        setVisible={() => {
          setChangeTitlePopup(false);
        }}
        onCloseButton
        render={() => {
          return (
            <>
              <header className="modal-header">
                <h3 className="layer-tit2">설계 제목 편집</h3>
              </header>
              <div className="cont">
                <SatInput
                  type="text"
                  ref={titleInputRef}
                  value={planTitle}
                  border
                  onChange={value => handlerChangePlanTitle(value)}
                  onPressEnter={handlerTitleBlur}
                  textLength={15}
                />
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => changePlanTitle()}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        type="fullPop"
        visible={isShowEaPopup}
        setVisible={() => {
          setEaMainPopup(false);
          handleReSearch();
        }}
      >
        <EaIndex
          setEaMainPopup={flag => {
            setEaMainPopup(flag);
            handleReSearch();
          }}
          planEstablishNo={financialPDFInfo.planEstablishNo}
          applicationNo={financialPDFInfo.applicationNo}
          isConstractChange={financialPDFInfo.fileType === 'E'} // 청약변경 진행 여부
          republishYn={isSelectRow.rePublishYn}
          republishType={$utils.getRepublishType(
            isSelectRow.republishType,
            financialPDFInfo.fileType === 'E',
          )}
          progressStep={isSelectRow.progressStep}
          policyNo={isSelectRow.policyNo}
        />
      </SatModal>

      <SatModal
        type="fullPop"
        visible={isShowOmniPopup}
        setVisible={() => {
          setOmniMainPopup(false);
          handleReSearch();
        }}
      >
        <OmniIndex
          setOmniMainPopup={flag => {
            setOmniMainPopup(flag);
            handleReSearch();
          }}
          planEstablishNo={financialPDFInfo.planEstablishNo}
          applicationNo={financialPDFInfo.applicationNo}
          republishType={$utils.getRepublishType(
            isSelectRow.republishType,
            financialPDFInfo.fileType === 'E',
          )} // 재발행 타입
          isSameDate={isSelectRow.planEstablishDate === getToday()}
          isConstractChange={financialPDFInfo.fileType === 'E'} // 청약변경 진행 여부
          isRepublish={$utils.checkPlanFlag(isSelectRow.rePublishYn)}
          isPartSub={isSelectRow.republishType === 'DOC'} // 부분재발행 여부
        />
      </SatModal>

      <SatModal
        visible={completePopup}
        setVisible={() => {
          setCompletePopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-left">
                  {`이미 청약접수가 된 설계입니다.`}
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => {
                    setCompletePopup(false);
                  }}
                />
              </div>
            </>
          );
        }}
      />

      <EaSelectModal
        isOpen={progressPopup}
        planInfo={isSelectRow}
        checkDocList={checkDocList}
        noUndecidedDocDataList={noUndecidedDocDataList}
        startEa={() => handleEaBookmarkSearch(isSelectRow)}
        startOmni={() => setOmniMainPopup(true)}
        onClose={() => {
          setProgressPopup(false);
        }}
      />

      <SatModal
        visible={isCancelOmniPopup}
        setVisible={() => {
          setIsCanceOmniPopup(false);
        }}
        type="confirm"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  고객에게 발송된 옴니청약을 취소하시겠어요?
                  <br />
                  옴니청약 취소 후 전자청약으로 변경하실 경우 가입설계를 다시
                  하셔야 합니다.
                </p>
              </div>
              <div className="btn-group">
                <SatButton
                  styleClass="btn-half cancel"
                  label={'아니오'}
                  onClick={() => setIsCanceOmniPopup(false)}
                />
                <SatButton
                  styleClass="btn-half confirm"
                  label={'예, 취소할게요.'}
                  onClick={() => handleCancelConfirmBtn()}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        visible={isNotProgress}
        setVisible={() => {
          setIsNotProgress(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {isNotProgressMsg}
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => {
                    handleIsNotProgressClose();
                  }}
                />
              </div>
            </>
          );
        }}
      />
      <SatModal
        type="fullPop"
        visible={eaPartSubPopup}
        setVisible={() => {
          setEaPartSubPopup(false);
        }}
      >
        <EaPartSubMain
          setEaPartSubPopup={setEaPartSubPopup}
          planEstablishNo={financialPDFInfo.planEstablishNo}
          applicationNo={financialPDFInfo.applicationNo}
          isSelectRow={isSelectRow}
          isConstractChange={isSelectRow.isConstractChange}
          republishType={$utils.getRepublishType(
            isSelectRow.republishType,
            isSelectRow.isConstractChange,
          )} // 재발행 타입
        />
      </SatModal>

      <SatModal
        visible={showStopPlanPop}
        setVisible={() => setShowStopPop(false)}
        type="newInfo"
        render={() => (
          <StopPlanPop
            checkRdopContList={checkRdopContList}
            setShowStopPop={setShowStopPop}
          />
        )}
      />
    </div>
  );
};
export default PlanListMain;
